module.exports = __webpack_public_path__ + "static/media/VIP_logo_large.8cf35255.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/VIP_logo_large.png
// module id = 1401
// module chunks = 0